<template>
  <div>
    <h3 class="text-xl mb-6">Additional Attendees</h3>
    <p class="text-xs mb-6">To register additional attendees, simply enter their details below.</p>
    <div v-for="(additionalUser, i) in order.additional_users" :key="i">
      <div class="w-full flex flex-wrap">
        <div class="w-full md:w-1/2 place-items-center">
          <h4 class="w-full mt-1 mb-4 text-lg">Attendee #{{ i + 2 }}</h4>
        </div>
        <div class="w-full md:w-1/2 text-right place-items-center">
          <button class="mb-4 px-3 py-2 bg-grey-lighter hover:text-white hover:bg-grey-darker" @click="removeUser(i)">X Delete Attendee</button>
        </div>
        <div class="w-full md:w-1/2 pr-3">
          <div class="flex-grow mr-1 mb-6">
            <label for="first_name" class="block text-xs mb-2">First Name<span class="text-primary">*</span></label>
            <input type="text" id="first_name" v-model="additionalUser.first_name" class="input w-full bg-white text-grey-darkest" :tabindex="i + 1 + '1'">
            <small class="block text-primary text-medium mt-2" v-if="errorBag.get('additional_users.' + i + '.first_name')" v-text="errorBag.get('additional_users.' + i + '.first_name')"></small>
          </div>
          <div class="flex-grow mr-1 mb-6">
            <label for="email_address" class="block text-xs mb-2">Email Address<span class="text-primary">*</span></label>
            <input type="text" id="email_address" v-model="additionalUser.email" class="input w-full bg-white text-grey-darkest" :tabindex="i + 1 + '3'">
            <small class="block text-primary text-medium mt-2" v-if="errorBag.get('additional_users.' + i + '.email')" v-text="errorBag.get('additional_users.' + i + '.email')"></small>
          </div>
        </div>
        <div class="w-full md:w-1/2 pl-3">
          <div class="flex-grow mr-1 mb-6">
            <label for="last_name" class="block text-xs mb-2">Last Name<span class="text-primary">*</span></label>
            <input type="text" id="last_name" v-model="additionalUser.last_name" class="input w-full bg-white text-grey-darkest" :tabindex="i + 1 + '2'">
            <small class="block text-primary text-medium mt-2" v-if="errorBag.get('additional_users.' + i + '.last_name')" v-text="errorBag.get('additional_users.' + i + '.last_name')"></small>
          </div>
          <div class="flex-grow mr-1 mb-6">
            <label for="dietary_requirements" class="block text-xs mb-2">Dietary Requirements<span class="text-primary">*</span></label>
            <input type="text" id="dietary_requirements" v-model="additionalUser.dietary_requirements" class="input w-full bg-white text-grey-darkest" :tabindex="i + 1 + '4'">
            <small class="block text-primary text-medium mt-2" v-if="errorBag.get('additional_users.' + i + '.dietary_requirements')" v-text="errorBag.get('additional_users.' + i + '.dietary_requirements')"></small>
          </div>
        </div>
      </div>
      <div class="w-full mb-4 pb-6 border-bottom border-grey-light">
        <div class="w-full block mb-4">
          <div class="inline-block pr-2"><input type="radio" id="ticket" class="align-middle cursor-pointer" value="" checked="checked" /></div>
          <label for="ticket" class="text-sm align-middle cursor-pointer">{{ conference.name }}</label>
        </div>
        <div v-for="(ticket, c) in tickets" :key="c" class="w-full block mb-2">
          <small class="block text-primary text-medium mt-2" v-if="errorBag.get('additional_users.' + i + '.ticket_id')" v-text="errorBag.get('additional_users.' + i + '.ticket_id')"></small>
        </div>
      </div>
    </div>
    <button class="mb-4 px-6 py-3 bg-grey-lighter text-primary focus:outline-none"  @click="addUser()">+ Add Another Attendee</button>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  props: ['conference', 'tickets', 'order', 'errorBag'],
  created () {
    if (this.registeringForOthers() && this.order.additional_users.length === 0) {
      this.addUser()
    }
  },
  methods: {
    addUser () {
      this.order.additional_users.push({
        first_name: '',
        last_name: '',
        email: '',
        dietary_requirements: 'None',
        ticket_id: null
      })
    },
    removeUser (i) {
      this.order.additional_users.splice(i, 1)
    },
    registeringForOthers () {
      return this.order.ticket_id === null || this.order.ticket_id === ''
    }
  }
}
</script>
